import { startPollingMessages } from './startPollingMessages';
import { chatbotSetSettings } from '../../services/chatbotSetSettings';
import { showAlert } from '../../slices/alertSlice';
import { TChatbotPeriodicity } from '../../types/chatbot';
import { TThunkAction } from '../../types/redux/thunk';

export const applyPeriodicitySettings =
  (periodicity: TChatbotPeriodicity): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    const result = await chatbotSetSettings(
      { httpApi, logger },
      {
        periodicity,
      },
    );

    if (!result) {
      dispatch(showAlert({ message: 'Сервисная ошибка. Попробуйте позже.' }));

      return;
    }

    dispatch(startPollingMessages());
  };
